<script setup>
  import { onMounted, ref, watch } from "vue";
  import Multiselect from "vue-multiselect";

  const props = defineProps({
    perPageOptions: {
      type: Array,
      required: true,
    },
  });

  const emit = defineEmits(["update:perPage"]);

  const selectedPerPage = ref(
    props.perPageOptions.find((option) => option.selected) || null
  );

  const perPageOptions = ref(props.perPageOptions);

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  watch(selectedPerPage, (newVal) => {
    if (newVal != null) {
      perPageOptions.value.forEach((option) => {
        if (option.value === newVal.value) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    }
    emit("update:perPage", newVal);
  });

  onMounted(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("perPage")) {
      const perPageFromUrl = parseInt(url.searchParams.get("perPage"));
      perPageOptions.value.forEach((option) => {
        if (option.value === perPageFromUrl) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
      selectedPerPage.value = perPageOptions.value.find((option) => option.selected);
    }
  });
</script>

<template>
  <div class="view-per-page-container">
    <Multiselect
      v-model="selectedPerPage"
      :options="perPageOptions"
      :searchable="false"
      :allow-empty="false"
      label="label"
      track-by="value"
      placeholder="View"
    >
      <template v-slot:singleLabel="{ option }">
        <span class="multiselect-label"><strong>{{ option.label }}</strong></span>
      </template>
      <template v-slot:placeholder>
        <span class="multiselect-label">{{ trans("View") }}</span>
      </template>
    </Multiselect>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  /*
    Adicione o seu CSS personalizado aqui.
    Você pode criar estilos que se apliquem tanto a .order-by-alpha-container
    quanto a .view-per-page-container para manter uma consistência visual.
  */
</style>
